export let ExperimentKeys;
(function (ExperimentKeys) {
  ExperimentKeys["ACQ0170"] = "acq-0170";
  ExperimentKeys["ACQ0173"] = "acq-0173";
  ExperimentKeys["ACQ0175"] = "acq-0175";
  ExperimentKeys["ACQ0177"] = "acq-0177";
})(ExperimentKeys || (ExperimentKeys = {}));
export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';